import { Controller } from "@hotwired/stimulus"
import Flatpickr from 'stimulus-flatpickr'

// Connects to data-controller="datepicker"
export default class extends Flatpickr {
  // automatically submit form when a date is selected
  change(selectedDates, dateStr, instance) {
    if (selectedDates.length !== 2) return;
    const form = this.element.closest("form");
    this.#setHidden(form, "start_date", instance.formatDate(selectedDates[0], "Y-m-d"));
    this.#setHidden(form, "end_date",   instance.formatDate(selectedDates[1], "Y-m-d"));
    form.submit();
  }

  #setHidden(form, name, value) {
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = Object.assign(document.createElement("input"), { type: "hidden", name });
      form.appendChild(input);
    }
    input.value = value;
  }
}
